import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-excel-docs',
  template: `
    <p>
      excel-docs-lib works!
    </p>
  `,
  styles: []
})
export class ExcelDocsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
